import axios from 'axios';


const API_HOST_URL = 'https://services.rappi.com'
const API_PREFIX_PATH = API_HOST_URL + '/core-home-proxy/cauth/s3'

const S3Api = {

  uploadImage: async (countryCode, file, token) => {
    try {
        const formData = new FormData();
        formData.append('object', file);
        
        const response = await axios.post(API_PREFIX_PATH + '/home-bucket', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                COUNTRY: countryCode.toUpperCase(),
                EXCLUDE_POSTFIX: true
            },
          });

      return response.data.s3_url;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default S3Api;
